export const inquiry_email = "inquiries@artistrybyisha.com";
export const instagram_url = "https://instagram.com/artistrybyisha";
export const thumbtack_url = "https://www.thumbtack.com/tx/austin/makeup-artists/";
